import { Alert } from "components/elements";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Checkbox, Col, Dropdown, Modal, Row, Space, Table, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import * as services from "../service/pendingApprovalApi";
import { setIsLoading, setPendingMovement } from "../slices/requestApprovalSlice";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import useOptions from "features/masterData/hooks/useOptions";
import { t } from "i18next";
// import { Modal } from "antd";
import { use } from "react";

function useMovement(
) {
    const dispatch = useDispatch()
    // console.log("history", history)

    const currentApprover = useSelector((state) => state.company.currentEmployee);
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const { pendingMovement = [], isLoading = false } = useSelector((state) => state.requestApproval)
    const [pagination, setPagination] = useState({ page: 0, size: 10 });
    const [sorter, setSorter] = useState([]);
    const { movementGroupOptions = [], getMovementGroupOptions } = useOptions();
    const { i18n } = useTranslation();
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selecttable, settable] = useState(null);
    const modifiedMovementGroupOptions = useMemo(() => {
        return [
            {
                label: i18n.language === "en" ? "All Movement Type" : "การดำเนินการทั้งหมด",
                value: ""
            },
            ...movementGroupOptions
        ];
    }, [i18n.language, movementGroupOptions]);



    function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
        if (!dateString) return;
        const date = dayjs(dateString, pattern);
        return date.format(reFormat);
    }






    const parseDataByMovementType = (oldData, newData, movementTypeName, movementTypeCode) => {
        if (!movementTypeName) return [];

        const oldDataString = JSON.stringify(oldData);
        const newDataString = JSON.stringify(newData);

        const movementTypes = movementTypeName.split(",").map((type) => type.trim());
        const oldDataSegments = oldDataString ? oldDataString.split("\n").filter((segment) => segment.trim() !== "") : [];
        const newDataSegments = newDataString ? newDataString.split("\n").filter((segment) => segment.trim() !== "") : [];

        while (oldDataSegments.length < movementTypes.length) {
            oldDataSegments.push("{}");
        }
        while (newDataSegments.length < movementTypes.length) {
            newDataSegments.push("{}");
        }

        return movementTypes.flatMap((movementType, index) => {
            const oldSegment = oldDataSegments[index];
            const newSegment = newDataSegments[index];

            console.log("newSegment", newSegment)

            try {
                const oldParsed = oldSegment ? JSON.parse(oldSegment) : {};
                const newParsed = newSegment ? JSON.parse(newSegment) : {};

                const formatDateArray = (dateArray) => {
                    if (Array.isArray(dateArray) && dateArray.length === 3) {
                        return `${dateArray[0]}/${String(dateArray[1]).padStart(2, '0')}/${String(dateArray[2]).padStart(2, '0')}`;
                    }
                    return "-";
                };

                const getNamePair = (value, isSupervisor = false) => {
                    if (!value || typeof value !== "object") {
                        return { th: value || "-", en: value || "-" };
                    }

                    if (Array.isArray(value)) {
                        const namesTh = value.map((v) => {
                            if (!v || typeof v !== "object") return "-";
                            const name = v.name || "-";
                            const surName = v.surName;
                            return surName ? `${name} ${surName}` : name;
                        });

                        const namesEn = value.map((v) => {
                            if (!v || typeof v !== "object") return "-";
                            const nameEn = v.nameEn || "-";
                            const surNameEn = v.surNameEn;
                            return surNameEn ? `${nameEn} ${surNameEn}` : nameEn;
                        });

                        return {
                            th: namesTh.join(", "),
                            en: namesEn.join(", "),
                        };
                    }

                    const name = value.name || "-";
                    const surName = value.surName;
                    const nameEn = value.nameEn || "-";
                    const surNameEn = value.surNameEn;

                    if (movementType === "ย้ายสายบังคับบัญชา" && isSupervisor) {
                        return {
                            th: surName ? `${name} ${surName}` : name,
                            en: surNameEn ? `${nameEn} ${surNameEn}` : nameEn,
                        };
                    }

                    return {
                        th: name,
                        en: nameEn,
                    };
                };

                if (movementTypeCode === "MOVEMENT_01_05") {
                    return [
                        {
                            movementTypeName: movementType,
                            index: index + 1,
                            field: "daysProbation",
                            oldValue: oldParsed.daysProbation || "-",
                            newValue: newParsed.daysProbation || "-",
                            oldValueEn: oldParsed.daysProbation || "-",
                            newValueEn: newParsed.daysProbation || "-",
                        },
                        {
                            movementTypeName: movementType,
                            index: index + 1,
                            field: "dateContractExpire",
                            oldValue: formatDateArray(oldParsed.dateContractExpire),
                            newValue: formatDateArray(newParsed.dateContractExpire),
                            oldValueEn: formatDateArray(oldParsed.dateContractExpire),
                            newValueEn: formatDateArray(newParsed.dateContractExpire),
                        },
                        {
                            movementTypeName: movementType,
                            index: index + 1,
                            field: "extensionProbation",
                            oldValue: oldParsed.extensionProbation || "-",
                            newValue: newParsed.extensionProbation || "-",
                            oldValueEn: oldParsed.extensionProbation || "-",
                            newValueEn: newParsed.extensionProbation || "-",
                        },
                        {
                            movementTypeName: movementType,
                            index: index + 1,
                            field: "probationDate",
                            oldValue: formatDateArray(oldParsed.probationDate),
                            newValue: formatDateArray(newParsed.probationDate),
                            oldValueEn: formatDateArray(oldParsed.probationDate),
                            newValueEn: formatDateArray(newParsed.probationDate),
                        },
                    ];
                } else {
                    const allFields = new Set([
                        ...Object.keys(oldParsed),
                        ...Object.keys(newParsed),
                    ]);

                    return Array.from(allFields).map((field) => {
                        const oldVal = oldParsed[field];
                        const newVal = newParsed[field];

                        let oldValue = "-";
                        let newValue = "-";
                        let oldValueEn = "-";
                        let newValueEn = "-";

                        if (Array.isArray(oldVal) && typeof oldVal[0] === "number" && oldVal.length === 3) {
                            oldValue = formatDateArray(oldVal);
                            oldValueEn = oldValue;
                        } else if (typeof oldVal === "object") {
                            const { th, en } = getNamePair(oldVal, field === "supervisor");
                            oldValue = th;
                            oldValueEn = en;
                        } else if (oldVal !== undefined) {
                            oldValue = oldVal;
                            oldValueEn = oldVal;
                        }

                        if (Array.isArray(newVal) && typeof newVal[0] === "number" && newVal.length === 3) {
                            newValue = formatDateArray(newVal);
                            newValueEn = newValue;
                        } else if (typeof newVal === "object") {
                            const { th, en } = getNamePair(newVal, field === "supervisor");
                            newValue = th;
                            newValueEn = en;
                        } else if (newVal !== undefined) {
                            newValue = newVal;
                            newValueEn = newVal;
                        }

                        return {
                            movementTypeName: movementType,
                            index: index + 1,
                            field,
                            oldValue,
                            newValue,
                            oldValueEn,
                            newValueEn,
                        };
                    });
                }
            } catch (error) {
                console.error("Error parsing segment:", { oldSegment, newSegment, error });
                return [];
            }
        });
    };


    const onRowClick = useCallback((record) => {
        if (!record) return;

        const enrichedRecord = {
            ...record,
        };

        setSelectedRow(enrichedRecord);
        setModalOpen(true);


        const tableData = parseDataByMovementType(record?.movement?.oldData, record?.movement?.newData, record.movementType.name);
        settable(tableData);


    }, []);

    const getPendingMovement = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const response = await services.getPendingMovement({
                ...pagination,
                companyId: currentCompany,
                approverId: currentApprover,
                employeeId: currentApprover,
                pagingType: "pending"
            })

            if (response?.data?.content) {
                const transformedPendingMovement = response.data?.content.map((movement) => {
                    if (movement.movement?.oldData?.employmentDate) {
                        movement.movement.oldData.employmentDate = dayjs(
                            movement.movement.oldData.employmentDate
                        ).format('DD/MM/YYYY');
                    }

                    if (movement.movement?.newData?.employmentDate) {
                        movement.movement.newData.employmentDate = dayjs(
                            movement.movement.newData.employmentDate
                        ).format('DD/MM/YYYY');
                    }

                    if (movement.movement?.oldData?.probationDate) {
                        movement.movement.oldData.probationDate = dayjs(
                            movement.movement.oldData.probationDate
                        ).format('DD/MM/YYYY');
                    }

                    if (movement.movement?.newData?.probationDate) {
                        movement.movement.newData.probationDate = dayjs(
                            movement.movement.newData.probationDate
                        ).format('DD/MM/YYYY');
                    }

                    if (movement.movement?.oldData?.dateofexpriaion) {
                        movement.movement.oldData.dateofexpriaion = dayjs(
                            movement.movement.oldData.dateofexpriaion
                        ).format('DD/MM/YYYY');
                    }


                    if (movement.movement?.newData?.dateofexpriaion) {
                        movement.movement.newData.dateofexpriaion = dayjs(
                            movement.movement.newData.dateofexpriaion
                        ).format('DD/MM/YYYY');
                    }

                    return movement;
                });


                dispatch(setPendingMovement(transformedPendingMovement));

                // // Alert({ message: "success" })
            }
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany,
        currentApprover])

    // useEffect(() => {
    //     if (history) {
    //         getPendingMovement(history)
    //         console.log("history")
    //     }
    // }, [history,])

    const onSearchMovement = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true))
            const response = await services.getPendingMovement({
                ...pagination,
                companyId: currentCompany,
                approverId: currentApprover,
                // employeeId: currentApprover,
                pagingType: "pending",
                ...values,
            })
            dispatch(setPendingMovement(response?.data?.content))
            // Alert({ message: "success" })
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany,
        currentApprover])

    function toPaginationParams(params = {}) {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            ...params,
            page: pagination.page || 0,
            size: pagination.pageSize || 10,
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;
    }
    const onPageChange = useCallback(
        (tablePagination, _, tableSorter) => {
            setPagination(tablePagination);
            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            setSorter(modifiedSorter);
            const modifiedParams = toPaginationParams({
                pagination: {
                    page: tablePagination.current - 1,
                    pageSize: tablePagination.pageSize,
                },
                sortBy: modifiedSorter,
            });
            getPendingMovement(modifiedParams);
        },
        [getPendingMovement]
    )

    const onApprove = useCallback(async (record) => {



        Modal.confirm({
            title: t('dialog.confirmation.header'),
            content: (
                <>
                    <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
                        {/* <Col span={24}>
                          </Col>
                          <Col span={12}>
                            <span>{t("document.create_date")}: <strong>{selectedRow?.sequence || "-"}</strong></span>
                          </Col>
                          <Col span={12}>
                            <span>{t("document.effective_date")}: <strong>{dayjs(selectedRow?.effectiveDate).format("DD/MM/YYYY") ? i18n.language === "en" ? dayjs(selectedRow?.effectiveDate).format("DD/MM/YYYY") : dayjs(selectedRow?.effectiveDate).format("DD/MM/BBBB") : '-'} </strong></span>
                          </Col>
                          <Col span={12}>
                
                            <span>{t("document.type")}:  <strong>{i18n.language === "en" ? selectedRow?.movementType?.nameEn : selectedRow?.movementType.name}</strong></span>
                          </Col>
                          <Col span={12}>
                          
                            {selectedRow?.movementDetails?.approveStatusEn === "Approved" ?
                              <span>{t("document.approved_date")}: <strong>{selectedRow?.movementDetails?.updateBy === 'null' ? dayjs(selectedRow?.movementDetails?.createDate).format("DD/MM/YYYY") : dayjs(selectedRow?.movementDetails?.createDate).format("DD/MM/YYYY")}</strong></span>
                              : <span>{t("document.approved_date")}: <strong> - </strong></span>
                            }
                          </Col> */}
                        <Col span={24}>
                        </Col>
                        <Col span={12}>
                            <span>{t("document.number")}: <strong>{selectedRow?.sequence || "-"}</strong></span>
                        </Col>
                        <Col span={12}>
                            <span>{t("document.create_date")}: <strong>{formatDate({ dateString: selectedRow?.createDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
                        </Col>
                        <Col span={12}>
                            <span>{t("document.created_by")}: <strong>{i18n.language === "en" ? selectedRow?.createBy?.nameEn : selectedRow?.createBy?.name} {i18n.language === "en" ? selectedRow?.createBy?.surNameEn : selectedRow?.createBy?.surName}</strong></span>
                        </Col>
                        <Col span={12}>
                            <span>{t("document.effective_date")}: <strong>{formatDate({ dateString: selectedRow?.effectiveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
                        </Col>

                        {/* <Col span={12}>
                                {selectedRow?.approveStatusEn === "Approved" ? (
                                  <span>{t("document.approved_date")}: <strong>{selectedRow?.approveDate !== 'null' ? formatDate({ dateString: selectedRow?.approveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : formatDate({ dateString: selectedRow?.approveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
                                ) : (
                                  <span>{t("document.approved_date")}: <strong>-</strong></span>
                                )}
                              </Col> */}

                        <Col span={12}>
                            <span>{t("document.type")}: <strong>{i18n.language === "en" ? selectedRow?.movementType.nameEn : selectedRow?.movementType.name}</strong></span>
                        </Col>
                        {/* <Col span={12}>
                                <span>{t("document.approved_by")}:
                                  <strong>
                                    {selectedRow?.timeline
                                      ?.filter(item => item.approveStatusEn === "Approved")
                                      .map((item, index) => (
                                        <div key={index}>
                                          {t("document.approver_number")} {index + 1} :
                                          {i18n.language === "en"
                                            ? `${item.employee.nameEn} ${item.employee.surNameEn}`
                                            : `${item.employee.name} ${item.employee.surName}`}
                                        </div>
                                      ))}
                                  </strong>
                                </span>
                              </Col> */}
                    </Row>
                //     <p>{t('message.areYouSureConfirmToAPPROVEDTheRequest')}</p>
                </>
            ),
            async onOk() {
                try {

                    let formattedNewSalary

                    if (record?.movementType?.code === 'MOVEMENT_03_01' && record?.movement?.newData?.salary) {
                        formattedNewSalary = record?.movement?.newData?.salary;
                        formattedNewSalary = formattedNewSalary.replace(/,/g, '');
                        console.log(formattedNewSalary)
                    }

                    console.log(record)
                    dispatch(setIsLoading(true))
                    const requestBody = {
                        companyId: currentCompany,
                        approverId: currentApprover,
                        employeeId: currentApprover,
                        actionId: currentApprover,
                        requestIds: record?.id,
                        movenmentId: record?.requestId,
                        sendingType: "APPROVED",
                        movement: {
                            newData: formattedNewSalary ?? record?.movement?.newData
                        }
                    }

                    await services.approveMovement(requestBody)
                    getPendingMovement()

                } catch (error) {
                    Alert({ type: "error", resultObject: error })
                } finally {
                    dispatch(setIsLoading(false))
                }
            },
            okText: t('common.confirm'),
            cancelText: t('common.cancel'),
        });

    }, [currentCompany, currentApprover, isLoading])

    const onReject = useCallback(async (record) => {
        try {

            let formattedNewSalary

            if (record?.movementType?.code === 'MOVEMENT_03_01' && record?.movement?.newData?.salary) {
                formattedNewSalary = record?.movement?.newData?.salary;
                formattedNewSalary = formattedNewSalary.replace(/,/g, '');
                console.log(formattedNewSalary)
            }
            dispatch(setIsLoading(true))
            const requestBody = {
                companyId: currentCompany,
                approverId: currentApprover,
                employeeId: currentApprover,
                actionId: currentApprover,
                requestIds: record?.id,
                movenmentId: record?.requestId,
                sendingType: "REJECT",
                movement: {
                    newData: formattedNewSalary ?? record?.movement?.newData
                }
            }
            await services.approveMovement(requestBody)
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentApprover, isLoading])

    const onReturn = useCallback(async (record) => {
        Modal.confirm({
            title: t('dialog.confirmation.header'),
            content: (
                <>
                    <p>{t('message.areYouSureConfirmToRETURNTheRequest')}</p>
                </>
            ),
            async onOk() {
                try {
                    dispatch(setIsLoading(true))
                    const requestBody = {
                        companyId: currentCompany,
                        approverId: currentApprover,
                        employeeId: currentApprover,
                        actionId: currentApprover,
                        requestIds: record?.requestId,
                        sendingType: "RETURN"
                    }
                    await services.approveMovement(requestBody)
                } catch (error) {
                    Alert({ type: "error", resultObject: error })
                } finally {
                    dispatch(setIsLoading(false))
                }
            },
            okText: t('common.confirm'),
            cancelText: t('common.cancel'),
        });
    }, [currentCompany, currentApprover, isLoading])

    const onCancel = useCallback(async (record) => {
        try {
            dispatch(setIsLoading(true))
            const requestBody = {
                companyId: currentCompany,
                approverId: currentApprover,
                employeeId: currentApprover,
                actionId: currentApprover,
                requestIds: record?.requestId,
                sendingType: "CANCELLED"
            }
            await services.approveMovement(requestBody)
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentApprover, isLoading])

    const onDelete = useCallback(async (record) => {
        try {
            dispatch(setIsLoading(true))
            const requestBody = {
                companyId: currentCompany,
                approverId: currentApprover,
                employeeId: currentApprover,
                actionId: currentApprover,
                requestIds: record?.requestId,
                sendingType: "CANCELLED"
            }
            await services.approveMovement(record)
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentApprover, isLoading])


    // useEffect(() => {
    //     if (currentCompany) {
    //         getPendingMovement({
    //             page: 0,
    //             size: 10
    //         })
    //         getMovementGroupOptions({ companyId: currentCompany })
    //     }
    // }, [currentCompany, getMovementGroupOptions])
    useEffect(() => {
        if (!currentCompany) return;
        (async () => {
            await getPendingMovement({ page: 0, size: 10 });
            getMovementGroupOptions({ companyId: currentCompany });
        })();
    }, [currentCompany]);

    // useEffect(() => {
    //     getMovement();
    //     if (currentCompany && id) {
    //         getMovementGroupOptions({
    //             companyId: currentCompany,
    //             employeeId: id,
    //         });
    //     }
    // }, [currentCompany, currentEmployee, getMovement, getMovementGroupOptions, id]);





    return {
        // dataSource: pendingMovement,
        isLoading,
        // onApprove,
        modifiedMovementGroupOptions,
        onCancel,
        onSearchMovement,
        onReject,
        onReturn,
        onChange: onPageChange,
        parseDataByMovementType,
        isModalOpen,
        setModalOpen,
        selectedRow,
        selecttable,
        onRowClick,

    }
}
export default useMovement